import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/logo.png'
import _imports_1 from '@/assets/images/location.png'
import _imports_2 from '@/assets/images/logo-1.png'
import _imports_3 from '@/assets/images/qrcode.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "nav-left" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "logo"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "nav-title" }, "轻食易安")
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_3 = { class: "nav-column" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "education-list"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"footer\"><div class=\"footer-div\"><div class=\"footer-top\"><span>平台性能有保障</span><span>微服务架构更灵活</span><span>定期更新功能及版本升级</span><span>24小时在线客服</span><span>各类应急救援服务</span></div><div class=\"footer-bottom\"><div><img src=\"" + _imports_2 + "\"><div>轻食易安食材供应链监管云平台</div></div><div><img src=\"" + _imports_3 + "\"><div>扫码关注公众号</div></div></div></div></div>", 1)

import { onMounted, ref, reactive } from "vue";
import { queryHomeList, queryAllTenantList } from "@/api/api";
import { jyj_columnfirst_management, SysTenant } from "./model/sysModel";
import { useStore } from "@/store/store";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const education = ref("");
const educationList = ref<SysTenant[]>();
const isShowEducation = ref<boolean>(false);
const firstColumnList = ref<jyj_columnfirst_management[]>([]);
const store = useStore();
const router = useRouter();

onMounted(async () => {
  let res = await queryAllTenantList();
  if (res.success) {
    educationList.value = res.result;
    education.value = res.result[0]?.name;
    store.setTenantId(res.result[0]?.id);
    await getFirstColumnData();
  }
  document.addEventListener("click", (e) => {
    if (
      e.target.className !== "education-list" &&
      e.target.className !== "nav-education" &&
      document.getElementsByClassName("education-list").length > 0
    ) {
      document.getElementsByClassName("education-list")[0].style.display =
        "none";
    }
  });
});
/**
 * 教育局点击
 */
function handleClick() {
  isShowEducation.value = !isShowEducation.value;
}

/**
 * 登录
 */
function login() {
  window.open(process.env.VUE_APP_BACKGROUND_MANAGEMENT, "scadmin");
}

/**
 * 选择教育局
 */
async function handleCheck(item: SysTenant) {
  education.value = item.name;
  isShowEducation.value = false;
  store.setTenantId(item.id);
  await getFirstColumnData();
}

/**
 * 获取一级栏目
 */
async function getFirstColumnData() {
  let res = await queryHomeList({ pageNo: 1, pageSize: 5 });
  if (res.success) {
    firstColumnList.value = [
      { columnName: "首页", id: "首页" },
      { columnName: "教育部公开", id: "教育部公开" },
      ...res.result.records,
      {
        columnName: "下载管理",
        id: "下载管理",
      },
    ];
    handleColumnCheck(firstColumnList.value[0]);
  }
}

/**
 * 栏目选择
 */
function handleColumnCheck(item: jyj_columnfirst_management) {
  store.setFirstColumn(item);
  let name = "";
  if (item.id === "首页") {
    name = "home";
  } else {
    name = "list";
  }
  router.push({ name });
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", {
      class: _normalizeClass(["nav", _unref(store)?.bgColorGradient ? 'nav-bg-gradient' : 'nav-bg'])
    }, [
      _hoisted_1,
      _createElementVNode("div", {
        class: "nav-education",
        onClick: handleClick
      }, [
        _hoisted_2,
        _createTextVNode(" " + _toDisplayString(education.value), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(firstColumnList.value, (item) => {
          return (_openBlock(), _createElementBlock("span", {
            key: item.id,
            onClick: ($event: any) => (handleColumnCheck(item)),
            class: _normalizeClass({ activation: _unref(store)?.getFirstColumn?.id === item?.id })
          }, _toDisplayString(item.columnName), 11, _hoisted_4))
        }), 128))
      ]),
      _createElementVNode("div", {
        class: "nav-login",
        onClick: login
      }, "登录")
    ], 2),
    (isShowEducation.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(educationList.value, (item) => {
            return (_openBlock(), _createElementBlock("span", {
              key: item.id,
              onClick: ($event: any) => (handleCheck(item)),
              class: _normalizeClass({ checked: item.name === education.value })
            }, _toDisplayString(item.name), 11, _hoisted_6))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view),
    _hoisted_7
  ], 64))
}
}

})